
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/topics/[slug]",
      function () {
        return require("private-next-pages/community/topics/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/topics/[slug]"])
      });
    }
  